export default "__VITE_ASSET__CDX$MWgO__"